"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlChargingValidation = void 0;
const ChargerControlChargingPortStateValidation_1 = require("./ChargerControlChargingPortStateValidation");
const ChargerControlChargingPowerLimitCommandValidation_1 = require("./ChargerControlChargingPowerLimitCommandValidation");
class ChargerControlChargingValidation {
    static isValid(entity) {
        // Validate entity.ports for existence and correct type.
        if (entity.ports == undefined)
            return false;
        if (!Array.isArray(entity.ports))
            return false;
        if (!entity.ports.every((elem) => {
            if (!ChargerControlChargingPortStateValidation_1.ChargerControlChargingPortStateValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        // If entity.active_power_limit_command exists, validate that it has the correct type.
        if (entity.active_power_limit_command != undefined) {
            if (!ChargerControlChargingPowerLimitCommandValidation_1.ChargerControlChargingPowerLimitCommandValidation.isValid(entity.active_power_limit_command))
                return false;
        }
        return true;
    }
}
exports.ChargerControlChargingValidation = ChargerControlChargingValidation;
